// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__1yI70","noItems":"List_noItems__GKHp6"};